import { register, CloudObject, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class DGJournalEntry extends CloudObject {

}

// Hardcoded tags
register('01917f9e19a4d68bab9c', DGJournalEntry);
DGJournalEntry.memoProp = defineProperty('01917f9e5f3ab54d6278');
DGJournalEntry.referenceProp = defineProperty('01917f9e6ef88d132aca');
DGJournalEntry.reference2Prop = defineProperty('01917f9e8789c1e0e4a7');
DGJournalEntry.referenceDateProp = defineProperty('01917fb523a83df71e39');
DGJournalEntry.amountProp = defineProperty('01917f9ec5513dfa1b44');
DGJournalEntry.statusProp = defineProperty('01917fb4c5f1ec4decc4');
DGJournalEntry.syncDateProp = defineProperty('01917fb545d03500d821');
DGJournalEntry.errorProp = defineProperty('01917fb55f16b12bdeba');
DGJournalEntry.JdtNumProp = defineProperty('0191dc8dee453eb7faea');
